export const AGENT_NAMES = {
    INTENT_CLASSIFIER: 'intent_classifier',
    ENTITY_DESIGNER: 'entity_designer',
    PAGE_PLANNER: 'page_planner',
    QUERY_BUILDER: 'query_builder',
    DATA_SYNTHESIZER: 'data_synthesizer',
    COMPONENT_BUILDER: 'component_builder',
    PAGE_ENGAGEMENT_BAR_BUILDER: 'page_engagement_bar_builder',
    PAGE_ARCHITECT: 'page_architect',
    PAGE_USER_AVATAR_BUILDER: 'page_user_avatar_builder',
    PAGE_VISIT_TRACKER: 'page_visit_tracker',
    PAGE_TOP_LIST_BUILDER: 'page_top_list_builder',
    PAGE_SEARCH_BAR_BUILDER: 'page_search_bar_builder',
    PAGE_DATA_LIST_BUILDER: 'page_data_list_builder',
    PAGE_PAGINATION_BUILDER: 'page_pagination_builder',
    PAGE_BREADCRUMB_BUILDER: 'page_breadcrumb_builder',
    PAGE_DETAIL_HERO_BUILDER: 'page_detail_hero_builder',
    PAGE_RELATED_ITEMS_BUILDER: 'page_related_items_builder',
    PAGE_TABLE_VIEW_BUILDER: 'page_table_view_builder',
    PAGE_CONTACT_FORM_BUILDER: 'page_contact_form_builder',
    PAGE_IMAGE_CAROUSEL_BUILDER: 'page_image_carousel_builder',
    PAGE_FAQ_ACCORDION_BUILDER: 'page_faq_accordion_builder',
    SYSTEM_ARCHITECT: 'system_architect',
    SYSTEM_IMPLEMENTER: 'system_implementer',
} as const;

export type AgentName = typeof AGENT_NAMES[keyof typeof AGENT_NAMES];
